// DEPENDENCIES
import isObject from 'lodash/isObject';

import { formatMessage } from 'commons/js/utils/strings';

export default {
	data() {
		return {
			defaultErrorMessage: {
				invalidData: 'Dado inválido! Verifique sua resposta.',
				requiredShort: 'Campo obrigatório.',
				required: 'Campo obrigatório! Não esqueça de preenchê-lo.',
				alpha: 'Dado inválido! Verifique sua resposta.',
				alphaNum: 'Dado inválido! Verifique sua resposta.',
				minLength: 'Dado inválido! Verifique sua resposta.',
				maxLength: 'Por favor, reduza o número de caracteres para poder continuar.',
				minValue: 'Dado inválido! Verifique sua resposta.',
        minValueWithParam: 'Digite um valor maior ou igual a %TERM0%.',
				maxValue: 'Dado inválido! Verifique sua resposta.',
        maxValueWithParam: 'Digite um valor menor ou igual a %TERM0%.',
				email: 'Endereço de e-mail inválido! Verifique sua resposta.',
				sameAsEmail: 'Endereço de e-mail inválido! Verifique sua resposta.',
				cpf: 'CPF inválido! Verifique sua resposta.',
				cnpj: 'CNPJ inválido! Verifique sua resposta.',
				birthDate: 'Data inválida! Verifique sua resposta.',
				phoneValid: 'Digite um telefone válido.',
				phoneFixed: 'Telefone inválido! Verifique sua resposta.',
				phoneMobile: 'Número de celular inválido! Verifique sua resposta.',
				sameAsPassword: 'Senhas não compatíveis. Verifique se você digitou corretamente.',
				password: 'Senha fraca! Combine letras e números.',
				isUnique: 'Este __field__ já está cadastrado.',
				decimal: 'Dado inválido! Verifique sua resposta.',
				creditCard: 'Número de cartão inválido.',
				invalidCreditCardType: 'Bandeira não atendida.',
				creditCardDate: 'Data inválida. Digite o formato de mm/aa.',
				cep: 'CEP inválido! Verifique sua resposta.',
				minWeight: 'Digite um peso válido.',
        minWeightWithParam: 'Digite um peso maior ou igual a %TERM0% kg.',
				maxWeight: 'Peso ultrapassa o limite.',
        maxWeightWithParam: 'Digite um peso menor que %TERM0% kg.',
        validWeight: 'Digite um formato de peso válido.',
				minDimensions: 'Digite uma medida válida.',
        minDimensionsWithParam: 'Digite uma medida maior ou igual a %TERM0%.',
				maxDimensions: 'Medida ultrapassa o limite.',
        maxDimensionsWithParam: 'Medida ultrapassa o limite de %TERM0%.',
				url: 'Deve ter formato de URL e conter “https://“.',
				shipmentServices: 'Ative pelo menos um serviço para continuar o cadastro do seu aplicativo.',
				minMaxLength: 'O nome deve conter entre %TERM0% e %TERM1% caracteres.',
				nfeKey: 'Chave de NF-e inválida! Verifique se a mesma está correta.',
				nfse: 'Chave da nota fiscal inválida! Verifique sua resposta.',
				nfseModel: '%TERM0% aceita Nota Fiscal apenas %TERM1% %TERM2%.',
				invalidParanaModel: 'Envios com origem no estado do Paraná devem usar uma NF-e do modelo 55.',
				cnae: 'CNAE inválido! Verifique se o mesmo está correto.',
				sameDocuments: 'Insira um documento diferente do %TERM0%.',
				minPrice: 'Preço inferior ao permitido. %TERM0%.',
				maxPrice: 'Preço superior ao permitido. %TERM0%.',
        sameAddress: 'Os endereços de remetente e destinatário não podem ser iguais.'
			}
		};
	},

	computed: {
		validForm() {
			return this.$v && !this.$v.$invalid;
		},

		showErrors() {
			return this.$v && this.$v.$dirty;
		}
	},

	methods: {
		validateForm() {
			let $field;

			this.$v.$touch();

			window.setTimeout(() => {
				$field = document.querySelector('.form--error');

				if ($field) {
					$field.querySelector('input, textarea, select').focus();
					window.scrollTo(0, window.scrollY - 80);
				}
			}, 100);

			return this.validForm;
		},

		validField(v) {
			return this.showErrors && v;
		},

		invalidField(field) {
			return field.$error;
		},

    findErrorType(errorField, validations) {
			return validations.find(validation => validation in errorField && !errorField[validation]);
		},

    /**
     * Sets dynamic error message considering the given validation parameters.
     *
     * @param {object} field - The field being validated.
     * @param {array} validationRules - The validation rules attached to the field.
     * @returns {string} - The properly error message, considering the given field, validations and params.
     */
    setDynamicErrorMessage(field, validationRules) {
      const errorType = this.findErrorType(field, validationRules);

      if (!errorType) {
        return;
      }

      const validationParams = field.$params;

      if (isObject(validationParams[errorType])) {
        // Filtering Vuelidate native instance properties that contains the '$' character.
        const keys = Object.keys(validationParams[errorType]).filter(key => !key.includes('$'));

        const messageParams = keys.length > 1 ? keys.map(key => validationParams[errorType][key]) : [validationParams[errorType][keys[0]]];

        return this.setErrorMessageWithParams(field, validationRules, messageParams);
      }

      return this.setErrorMessage(field, validationRules);
    },

		setErrorMessage(errorField, validations) {
			const errorType = this.findErrorType(errorField, validations);

			return this.defaultErrorMessage[errorType];
		},

    /**
		 * Sets the error message with dynamic params in the text.
		 * @param {object} errorField - the field being validated
		 * @param {array<string>} validations - the array containing the available validations for the field(s)
		 * @param {array<string>} messageParams - the array containing the params to be replaced in the text
		 * @returns {string}
		 */
		setErrorMessageWithParams(errorField, validations, messageParams) {
			const errorMessage = this.setErrorMessage(errorField, validations);

			return formatMessage(errorMessage, messageParams);
		},
	}
};
